export default {
  "content": "<path d=\"M0 0h48v48H0z\" fill=\"none\"/><path d=\"M30 6h6v36h-6z\" fill=\"#D7D8DE\"/><path d=\"M25 21.5h2v5h-2z\" fill=\"#3F4450\"/><path d=\"M37 41V6a1 1 0 00-1-1h-5V3a.998.998 0 00-1.165-.986l-18 3A1 1 0 0011 6v35H2v2h9.917l17.918 2.986A1 1 0 0031 45v-2h15v-2zm-8 2.819l-16-2.667V6.847L29 4.18zM35 41h-4V7h4z\" fill=\"#3F4450\"/>",
  "attrs": {
    "viewBox": "0 0 48 48",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};